import { GeographicBoundariesTable } from "@/features/service-areas/geographic-boundaries-table";

export function GeographicBoundaries() {
  return (
    <div className="container mx-auto py-6 px-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Geographic Boundaries</h1>
        <p className="text-gray-600 mt-2">
          Manage geographic boundaries that can be used as templates for
          creating service areas. Import from OpenStreetMap, upload GeoJSON
          files, or create custom boundaries.
        </p>
      </div>
      <GeographicBoundariesTable />
    </div>
  );
}
